import { useRef } from 'react';
import Cookies from 'js-cookie';

import { clearAllCookies } from 'src/utils/helper';

/**
 * Hook to manually poll for order payment result using cookies.
 *
 * @param {Object} options
 * @param {Function} [options.onSuccess] - Called on success message
 * @param {Function} [options.onError] - Called on failure message
 * @param {Function} [options.onReset] - Called after 4s if success
 */
export const useCarcPaymentPoller = ({ onSuccess, onError, onReset } = {}) => {
  const intervalRef = useRef(null);

  const startPolling = () => {
    if (intervalRef.current) {
      // console.log('[OrderPoller] Already polling...');
      return;
    }
    
    // Reset cookies before polling
    // console.log('[OrderPoller] Resetting cookies before polling...');
    Cookies.set('orderPaymentStatus', true, { path: '/', domain: '.shahen-sa.com' });
    Cookies.set('orderPaymentMessage', '', { path: '/', domain: '.shahen-sa.com' });

    // console.log('[OrderPoller] Started polling...');

    intervalRef.current = setInterval(() => {
      const status = Cookies.get('orderPaymentStatus');
      const message = Cookies.get('orderPaymentMessage');

      console.log('[OrderPoller] Cookies:', { status, message });

      if (status === 'false' || status === 'true' || (message && message.trim() !== '')) {
        const lowerMsg = message.toLowerCase();
        const successKeywords = [
          'success',
          'successfully',
          'transaction id is', // English
          'تم',
          'بنجاح',
          'معرف المعاملة', // Arabic
        ];
        // console.log('[OrderPoller] SUCCESS:', message);
        if (successKeywords.some((kw) => message.includes(kw))) {
          onSuccess?.({ data: { success: message } });
          clearAllCookies();
          setTimeout(() => {
            // console.log('[OrderPoller] Triggering onReset');
            onReset?.();
          }, 4000);
        } else if (lowerMsg.includes('fail')) {
          console.log('[OrderPoller] FAILURE:', message);
          onError?.({ data: { error: message } });
        }
      }
    }, 500);
  };

  const stopPolling = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      clearAllCookies();
      console.log('[OrderPoller] Manually stopped polling');
    }
  };

  return { startPolling, stopPolling };
};
